/** MIME type for drag-and-drop tab promotion between panes. */
export const DRAG_TAB_TYPE = "application/x-thread-tab";
